// extracted by mini-css-extract-plugin
export default {"modal":"CustomDashboardLimitErrorModal__modal___L8KmW","cancelBtn":"CustomDashboardLimitErrorModal__cancelBtn___d8cMr"};